<template>
  <div>
    <p class="caption mb-3" style="color: rgba(0,0,0,0.55)">Defina o valor do bônus para cada chassi selecionado.</p>

    <!-- Tipo de Meta -->
    <div class="mb-3" style="border: 1px solid rgba(0,0,0,0.12); border-radius: 8px; padding: 10px 12px; background: rgba(0,0,0,0.015)">
      <p class="caption font-weight-bold text-uppercase ma-0 mb-2" style="letter-spacing: 0.05em; font-size: 10px; color: rgba(0,0,0,0.7)">Tipo de Meta</p>
      <div class="d-flex" style="gap: 6px">
        <button
          v-for="opt in tiposMeta"
          :key="opt.value"
          type="button"
          @click="setTipoMeta(opt.value)"
          class="rounded pa-2 text-center caption font-weight-medium flex-grow-1"
          style="cursor: pointer; border: 2px solid; transition: all 0.2s; font-family: inherit; outline: none; -webkit-appearance: none; appearance: none"
          :style="form.tipoMeta === opt.value ? 'border-color: #1976d2; background: rgba(25,118,210,0.06); color: #1976d2' : 'border-color: rgba(0,0,0,0.12); background: white; color: rgba(0,0,0,0.6)'"
        >{{ opt.label }}</button>
      </div>
    </div>

    <v-alert type="info" dense text class="caption mb-3">
      <div class="mb-1"><strong>Meta:</strong> {{ descricaoTipoMeta }}</div>
      <div><strong>Chassi:</strong> {{ descricaoTipoChassi }}</div>
    </v-alert>

    <!-- Modo Coletivo -->
    <template v-if="form.tipoMeta !== 'individual'">
      <div class="mb-4" style="border: 1px solid rgba(0,0,0,0.12); border-radius: 8px; padding: 10px 12px; background: rgba(0,0,0,0.015)">
        <p class="caption font-weight-bold text-uppercase ma-0 mb-2" style="letter-spacing: 0.05em; font-size: 10px; color: rgba(0,0,0,0.7)">Chassis Selecionados</p>
        <div
          v-for="item in form.chassisSelecionados"
          :key="item.chassi_completo"
          class="d-flex align-center mb-2 pa-2 rounded"
          style="border: 1px solid rgba(0,0,0,0.12); background: white; gap: 12px"
        >
          <div class="flex-grow-1">
            <p class="body-2 font-weight-medium ma-0">{{ item.chassi_completo }}</p>
            <p class="caption ma-0" style="color: rgba(0,0,0,0.55)">{{ item.descricao_modelo }}</p>
          </div>
          <v-text-field
            v-model="item.valor_bonus"
            prefix="R$"
            type="number"
            dense
            outlined
            hide-details
            placeholder="0,00"
            style="max-width: 130px; flex-shrink: 0"
          ></v-text-field>
        </div>
      </div>
    </template>

    <!-- Modo Individual -->
    <template v-else-if="form.chassisSelecionados.length > 0 && form.colaboradoresSelecionados.length > 0">
      <div
        v-for="colab in form.colaboradoresSelecionados"
        :key="colab.id_colaborador"
        class="mb-3"
        style="border: 1px solid rgba(0,0,0,0.12); border-radius: 8px; padding: 12px 14px; background: rgba(0,0,0,0.015)"
      >
        <p class="body-2 font-weight-medium ma-0 mb-1" style="color: rgba(0,0,0,0.75)">{{ colab.colaborador }}</p>
        <p class="caption grey--text ma-0 mb-3">{{ colab._funcao }}</p>
        <div
          v-for="item in form.chassisSelecionados"
          :key="item.chassi_completo"
          class="d-flex align-center mb-2 pa-2 rounded"
          style="border: 1px solid rgba(0,0,0,0.12); background: white; gap: 12px"
        >
          <div class="flex-grow-1">
            <p class="body-2 font-weight-medium ma-0">{{ item.chassi_completo }}</p>
            <p class="caption ma-0" style="color: rgba(0,0,0,0.55)">{{ item.descricao_modelo }}</p>
          </div>
          <v-text-field
            :value="getIndividualItemValor(colab.id_colaborador, item.chassi_completo, 'valorBonus')"
            @input="setIndividualItemValor(colab.id_colaborador, item.chassi_completo, 'valorBonus', $event)"
            prefix="R$"
            type="number"
            dense
            outlined
            hide-details
            placeholder="0,00"
            style="max-width: 130px; flex-shrink: 0"
          ></v-text-field>
        </div>
      </div>
    </template>
    <div v-else-if="form.tipoMeta === 'individual'" class="mb-4">
      <v-alert type="info" dense text class="caption">Selecione colaboradores e chassis nas etapas anteriores para definir bônus individuais.</v-alert>
    </div>

    <!-- Custo estimado — chassi tem layout próprio: não tem "por colaborador" -->
    <div class="mt-3 rounded" style="border: 2px solid #bfdbfe">
      <div class="d-flex align-center pa-3" style="background: linear-gradient(135deg, #eff6ff, #eef2ff); border-radius: 6px 6px 0 0">
        <div class="d-flex align-center justify-center mr-2 flex-shrink-0" style="width: 28px; height: 28px; border-radius: 50%; background: #1d4ed8">
          <v-icon color="white" small>mdi-calculator</v-icon>
        </div>
        <div>
          <p class="body-2 font-weight-medium ma-0" style="color: #1e3a8a">Custo Estimado desta Meta</p>
          <p v-if="custoEstimado.total > 0" class="caption ma-0" style="color: #2563eb">
            {{ form.tipoMeta === 'individual' ? 'Soma dos bônus por colaborador' : 'Soma dos bônus dos chassis, cada chassi é vendido uma única vez' }}
          </p>
        </div>
      </div>
      <div v-if="custoEstimado.total === 0" class="pa-3" style="background: white; border-radius: 0 0 6px 6px">
        <v-alert type="info" dense text class="caption mb-0">
          Preencha os valores de bônus dos itens acima para visualizar a simulação de custo.
        </v-alert>
      </div>
      <div v-else class="pa-4" style="background: linear-gradient(135deg, #eff6ff, #eef2ff); border-radius: 0 0 6px 6px; border-top: 1px solid #bfdbfe">
        <div class="d-flex justify-space-between align-center">
          <span class="body-2" style="color: #1d4ed8">Total estimado</span>
          <span class="headline font-weight-bold" style="color: #1e3a8a">{{ formatarMoeda(custoEstimado.total) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import calculoMixin from "./calculoMixin";
import { calcCustoEstimadoChassi } from "./custoEstimadoUtils";

export default {
  name: "SubEtapaCalculoChassi",

  mixins: [calculoMixin],

  props: {
    form: { type: Object, required: true }
  },

  mounted() {
    this.setTipoMeta("coletiva");
  },

  computed: {
    custoEstimado() {
      if (this.form.tipoMeta === "individual") {
        let total = 0;
        const itens = this.form.metasIndividuaisItens || {};
        this.form.colaboradoresSelecionados.forEach(c => {
          const colItens = itens[c.id_colaborador] || {};
          this.form.chassisSelecionados.forEach(ch => {
            total += parseFloat((colItens[ch.chassi_completo] || {}).valorBonus) || 0;
          });
        });
        return { total };
      }
      return calcCustoEstimadoChassi(this.form.chassisSelecionados);
    }
  }
};
</script>
